/**
 * Created by alvinoktavianus on 5/18/17.
 */

import React, { Component } from 'react'
import _ from 'lodash'
import moment from 'moment'
import { connect } from 'react-redux'

import Header from '../Header'
import styles from './ActiveOutlets.css'

class ActiveOutlets extends Component {
  renderActiveOutlets () {
    const {outlets} = this.props
    return _.map(outlets, (outlet) => {
      let today = moment()
      if (moment(outlet.end_date).diff(today) > 0) {
        return (
          <div className={styles['mb-20px']} key={outlet.id}>
            <div className={styles['mb-10px']}>
              <p className={styles['outlet-name']}><strong>{outlet.name}</strong></p>
            </div>
            <div>Expiration Date: <strong>{moment(outlet.end_date).format('DD MMMM YYYY')}</strong></div>
          </div>
        )
      }
    })
  }

  render () {
    const {showLoadingSpinnerPage} = this.props
    return (!showLoadingSpinnerPage &&
      <div>
        <Header title='active outlets' />
        {this.renderActiveOutlets()}
      </div>
    )
  }
}

function mapStateToProps (state) {
  const {outlets} = state.setting.billing
  const {showLoadingSpinnerPage} = state.loadingSpinner
  return {outlets, showLoadingSpinnerPage}
}

export default connect(mapStateToProps)(ActiveOutlets)



// WEBPACK FOOTER //
// ./app/pages/AccountSetting/Billing/ActiveOutlets/ActiveOutlets.js